import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private currentLang = new BehaviorSubject<string>('bs');

  constructor(private translateService: TranslateService) {
    // Initialize with languages
    this.translateService.addLangs(['bs', 'en', 'cs', 'ar']);

    // Set default language
    this.translateService.setDefaultLang('bs');

    // Try to get language from localStorage
    const savedLang = localStorage.getItem('language');
    if (savedLang && this.translateService.getLangs().includes(savedLang)) {
      this.setLanguage(savedLang);
    } else {
      this.setLanguage('bs'); // Default to Bosnian
    }
  }

  /**
   * Set the current language
   * @param lang Language code (e.g., 'bs', 'en')
   */
  setLanguage(lang: string): void {
    this.translateService.use(lang);
    localStorage.setItem('language', lang);
    this.currentLang.next(lang);
  }

  /**
   * Get the current language
   * @returns Observable of the current language
   */
  getCurrentLang(): Observable<string> {
    return this.currentLang.asObservable();
  }

  /**
   * Get available languages
   * @returns Array of available language codes
   */
  getAvailableLanguages(): string[] {
    return this.translateService.getLangs();
  }

  /**
   * Translate a key
   * @param key Translation key
   * @param params Optional parameters for the translation
   * @returns Observable of the translated text
   */
  translateKey(key: string, params?: object): Observable<string> {
    return this.translateService.get(key, params);
  }

  /**
   * Translate a key instantly
   * @param key Translation key
   * @param params Optional parameters for the translation
   * @returns Translated text
   */
  instant(key: string, params?: object): string {
    return this.translateService.instant(key, params);
  }
}
